<template>
  <svg
    width="1em"
    height="1em"
    class="bi bi-shield-fill"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    role="presentation"
  >
    <title>Support</title>
    <path
      fill-rule="evenodd"
      d="M29.3,10.2h-7.5V2.7c0-1.5-1.2-2.7-2.7-2.7h-6.3c-1.5,0-2.7,1.2-2.7,2.7v7.5H2.7
		c-1.5,0-2.7,1.2-2.7,2.7v6.3c0,1.5,1.2,2.7,2.7,2.7h7.5v7.5c0,1.5,1.2,2.7,2.7,2.7h6.3c1.5,0,2.7-1.2,2.7-2.7v-7.5h7.5
		c1.5,0,2.7-1.2,2.7-2.7v-6.3C32,11.4,30.8,10.2,29.3,10.2z"
    />
  </svg>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'SupportIcon',
});
</script>
